import React from 'react';

export default function SafariInactive({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="url(#safari_inactive_paint0_linear)"
        d="M44 82.5c21.263 0 38.5-17.237 38.5-38.5S65.263 5.5 44 5.5 5.5 22.737 5.5 44 22.737 82.5 44 82.5z"
      />
      <path
        fill="url(#safari_inactive_paint1_radial)"
        d="M44 79.612c19.667 0 35.612-15.944 35.612-35.612 0-19.669-15.944-35.613-35.613-35.613C24.331 8.387 8.387 24.331 8.387 44c0 19.668 15.944 35.612 35.612 35.612z"
      />
      <path
        fill="#F3F3F3"
        d="M44.06 17.05c-.241 0-.452-.181-.452-.422v-6.286c0-.24.21-.421.452-.421.24 0 .45.18.45.42v6.287c-.03.24-.21.421-.45.421z"
      />
      <path
        fill="#EFEFEF"
        d="M44.06 17.08c-.271 0-.482-.21-.482-.451v-6.287c0-.24.21-.45.481-.45s.482.21.482.45v6.287c0 .24-.241.45-.482.45zm0-7.129c-.211 0-.422.18-.422.391v6.287c0 .21.18.39.421.39.21 0 .421-.18.421-.39v-6.287c-.03-.21-.21-.391-.42-.391z"
      />
      <path
        fill="#F3F3F3"
        d="M47.069 13.681c-.241-.03-.422-.21-.422-.45l.211-2.798c.03-.24.24-.421.481-.391.24.03.421.21.421.451l-.21 2.797a.438.438 0 01-.481.392z"
      />
      <path
        fill="#EFEFEF"
        d="M47.067 13.711a.488.488 0 01-.45-.48l.21-2.798c.03-.24.24-.451.511-.421.27.03.451.24.451.481l-.21 2.797c-.03.271-.24.452-.512.421zm.271-3.639c-.21 0-.421.15-.421.361l-.21 2.798c0 .21.15.39.39.42.211 0 .422-.15.422-.36l.21-2.798c0-.21-.18-.39-.391-.421z"
      />
      <path
        fill="#F3F3F3"
        d="M49.323 17.592a.462.462 0 01-.361-.512l1.233-6.166c.06-.24.27-.39.511-.33.24.06.391.27.361.51l-1.233 6.167c-.03.21-.27.36-.511.33z"
      />
      <path
        fill="#EFEFEF"
        d="M49.324 17.621a.49.49 0 01-.392-.541l1.234-6.166c.06-.24.3-.421.57-.361.272.06.422.3.392.541l-1.233 6.166c-.06.24-.3.391-.571.361zm1.413-7.008a.431.431 0 00-.481.3l-1.233 6.167c-.03.21.09.42.33.481.211.03.422-.09.482-.301l1.233-6.166c.03-.24-.12-.42-.331-.481z"
      />
      <path
        fill="#F3F3F3"
        d="M52.934 14.884a.45.45 0 01-.33-.541l.752-2.707c.06-.24.3-.361.54-.3.241.06.392.3.332.54l-.752 2.708c-.06.24-.301.36-.542.3z"
      />
      <path
        fill="#EFEFEF"
        d="M52.934 14.915c-.24-.06-.42-.33-.33-.571l.752-2.708c.06-.24.33-.39.57-.33.241.06.422.33.332.571l-.752 2.707c-.06.24-.3.391-.571.331zm.993-3.519c-.21-.06-.451.06-.511.27l-.752 2.708c-.06.21.06.42.3.48.211.061.452-.06.512-.27l.752-2.707a.432.432 0 00-.301-.481z"
      />
      <path
        fill="#F3F3F3"
        d="M54.408 19.125a.43.43 0 01-.24-.571l2.405-5.805c.09-.21.361-.331.572-.21.24.09.33.36.24.57l-2.406 5.806c-.09.21-.36.33-.571.21z"
      />
      <path
        fill="#EFEFEF"
        d="M54.406 19.156a.467.467 0 01-.27-.602l2.406-5.805c.09-.24.361-.33.632-.24a.468.468 0 01.27.601l-2.406 5.806c-.12.24-.391.36-.632.24zm2.738-6.587a.408.408 0 00-.542.21l-2.406 5.805c-.09.211.03.422.24.512.211.09.452 0 .542-.21l2.406-5.806a.428.428 0 00-.24-.511z"
      />
      <path
        fill="#F3F3F3"
        d="M58.468 17.2c-.21-.12-.3-.36-.21-.571l1.263-2.497a.44.44 0 01.601-.18c.21.12.3.36.21.571L59.07 17.02a.44.44 0 01-.601.18z"
      />
      <path
        fill="#EFEFEF"
        d="M58.468 17.23a.46.46 0 01-.21-.631l1.262-2.497a.46.46 0 01.632-.21c.24.12.331.39.21.632L59.1 17.02a.46.46 0 01-.631.21zm1.654-3.278c-.21-.09-.451-.03-.541.18l-1.264 2.497c-.09.18 0 .42.18.541.211.09.452.03.542-.18l1.264-2.497c.09-.18 0-.42-.18-.541z"
      />
      <path
        fill="#F3F3F3"
        d="M59.07 21.652c-.211-.15-.272-.42-.121-.601l3.489-5.204c.12-.21.391-.24.601-.12.211.15.271.421.12.601l-3.489 5.204c-.12.21-.39.271-.6.12z"
      />
      <path
        fill="#EFEFEF"
        d="M59.068 21.683a.52.52 0 01-.15-.662l3.489-5.204c.15-.21.42-.27.661-.12.211.15.271.451.151.662l-3.49 5.203a.48.48 0 01-.66.12zm3.97-5.926c-.18-.12-.45-.09-.571.09l-3.49 5.204c-.12.18-.06.421.121.541.18.12.451.09.572-.09l3.489-5.173a.428.428 0 00-.12-.572z"
      />
      <path
        fill="#F3F3F3"
        d="M63.46 20.539c-.18-.15-.24-.421-.09-.602l1.745-2.196c.15-.18.42-.21.601-.06.18.15.24.422.09.602l-1.744 2.196a.429.429 0 01-.601.06z"
      />
      <path
        fill="#EFEFEF"
        d="M63.431 20.57c-.21-.15-.24-.451-.09-.662l1.744-2.196c.15-.21.452-.24.662-.06.21.15.24.451.09.662l-1.744 2.196c-.15.21-.451.24-.662.06zm2.256-2.858c-.18-.15-.421-.12-.572.06l-1.744 2.196c-.12.18-.09.421.09.572.18.15.421.12.572-.06l1.744-2.196c.12-.18.09-.451-.09-.572z"
      />
      <path
        fill="#F3F3F3"
        d="M63.16 25.05c-.18-.18-.18-.45 0-.602l4.45-4.42c.182-.181.452-.151.603 0 .15.15.18.45 0 .6l-4.421 4.422a.436.436 0 01-.632 0z"
      />
      <path
        fill="#EFEFEF"
        d="M63.13 25.081a.472.472 0 010-.662l4.452-4.421a.472.472 0 01.662 0 .472.472 0 010 .662l-4.452 4.42a.472.472 0 01-.662 0v.001zm5.084-5.053a.418.418 0 00-.572 0l-4.451 4.421a.418.418 0 000 .572c.15.15.42.15.571 0l4.452-4.422c.15-.15.15-.39 0-.571z"
      />
      <path
        fill="#F3F3F3"
        d="M67.672 24.81c-.15-.18-.15-.45.03-.6l2.135-1.805a.43.43 0 01.602.06c.15.18.15.451-.03.601l-2.136 1.805a.43.43 0 01-.601-.06z"
      />
      <path
        fill="#EFEFEF"
        d="M67.642 24.84c-.18-.21-.15-.511.03-.662l2.135-1.804c.18-.18.481-.15.662.06.18.21.15.511-.03.662L68.303 24.9c-.18.18-.48.15-.661-.06zm2.767-2.376c-.15-.18-.391-.18-.571-.06l-2.136 1.805c-.15.15-.18.39-.03.57.15.181.391.181.571.061l2.136-1.805c.18-.15.18-.39.03-.571z"
      />
      <path
        fill="#F3F3F3"
        d="M66.468 29.142a.407.407 0 01.12-.602l5.234-3.489c.21-.12.481-.06.601.12.15.211.09.482-.12.602l-5.233 3.49c-.18.12-.451.06-.602-.121z"
      />
      <path
        fill="#EFEFEF"
        d="M66.438 29.141a.48.48 0 01.12-.661l5.234-3.49c.21-.15.511-.09.662.151a.48.48 0 01-.12.661l-5.234 3.49a.463.463 0 01-.662-.15zm5.955-3.94a.391.391 0 00-.54-.12l-5.235 3.489c-.18.12-.24.36-.09.571.12.18.361.24.542.12l5.233-3.488c.18-.15.21-.392.09-.572z"
      />
      <path
        fill="#F3F3F3"
        d="M70.951 29.773a.438.438 0 01.15-.602l2.437-1.383c.21-.12.481-.03.601.18s.06.481-.15.602l-2.437 1.383c-.21.12-.48.03-.601-.18z"
      />
      <path
        fill="#EFEFEF"
        d="M70.92 29.803c-.12-.24-.06-.512.15-.632l2.437-1.383c.21-.12.51-.03.631.18.12.24.06.512-.15.632l-2.437 1.384c-.21.12-.511.03-.631-.181zm3.188-1.805c-.12-.21-.36-.27-.541-.15l-2.437 1.384c-.18.12-.24.36-.15.54.12.211.36.272.541.151l2.437-1.383c.18-.09.24-.331.15-.542z"
      />
      <path
        fill="#F3F3F3"
        d="M68.935 33.773c-.09-.24 0-.48.24-.57l5.805-2.407c.21-.09.481.03.572.24.09.241 0 .482-.241.572l-5.805 2.406a.43.43 0 01-.571-.24z"
      />
      <path
        fill="#EFEFEF"
        d="M68.905 33.804c-.09-.24 0-.511.241-.632l5.805-2.406a.467.467 0 01.601.27c.09.241 0 .512-.24.632l-5.805 2.406a.468.468 0 01-.602-.27zm6.588-2.737a.428.428 0 00-.512-.24l-5.805 2.405c-.21.09-.3.331-.21.542.09.21.33.3.51.24l5.806-2.406c.21-.09.3-.33.21-.541z"
      />
      <path
        fill="#F3F3F3"
        d="M73.176 35.277c-.09-.241.03-.481.271-.572l2.647-.872c.21-.09.48.06.541.27.09.241-.03.482-.27.572l-2.647.873c-.21.09-.451-.03-.542-.272z"
      />
      <path
        fill="#EFEFEF"
        d="M73.146 35.308a.46.46 0 01.3-.601l2.647-.873c.24-.09.511.06.602.301a.46.46 0 01-.301.602l-2.647.872a.512.512 0 01-.601-.3zm3.489-1.142c-.06-.211-.301-.332-.512-.271l-2.646.872c-.21.06-.301.3-.24.511.06.21.3.331.51.27l2.647-.871c.21-.09.3-.301.24-.512z"
      />
      <path
        fill="#F3F3F3"
        d="M70.47 38.856c-.06-.24.09-.48.33-.51l6.166-1.204c.24-.06.45.12.51.36.061.241-.09.482-.33.512l-6.166 1.203c-.24.03-.48-.12-.511-.36z"
      />
      <path
        fill="#EFEFEF"
        d="M70.408 38.858a.484.484 0 01.361-.572l6.166-1.203c.24-.06.481.12.541.39.06.271-.12.512-.36.572l-6.167 1.203c-.24.06-.48-.12-.54-.39zm7.008-1.354a.403.403 0 00-.45-.331l-6.167 1.203c-.21.03-.36.27-.3.482.03.21.24.36.45.33l6.166-1.203c.211-.06.361-.27.301-.481z"
      />
      <path
        fill="#F3F3F3"
        d="M74.318 41.173c-.03-.24.12-.45.361-.48l2.767-.332c.24-.03.451.15.481.392.03.24-.12.45-.36.48l-2.768.332c-.21.03-.45-.15-.481-.392z"
      />
      <path
        fill="#EFEFEF"
        d="M74.288 41.172c-.03-.27.15-.511.391-.541l2.767-.33c.24-.031.481.15.512.42.03.27-.15.512-.391.542l-2.767.33a.468.468 0 01-.512-.42zm3.64-.42c-.03-.211-.24-.392-.452-.362l-2.767.331a.403.403 0 00-.33.451c.03.21.24.391.45.361l2.768-.33c.21-.03.36-.241.33-.452z"
      />
      <path
        fill="#F3F3F3"
        d="M70.95 44.09c0-.24.18-.45.421-.45h6.287c.24 0 .42.21.42.45 0 .242-.18.452-.42.452H71.37c-.24 0-.42-.21-.42-.451z"
      />
      <path
        fill="#EFEFEF"
        d="M70.92 44.09c0-.271.21-.482.451-.482h6.286c.241 0 .452.21.452.482 0 .27-.211.48-.452.48h-6.286c-.24 0-.451-.21-.451-.48zm7.128.03c0-.21-.18-.421-.39-.421H71.37c-.21 0-.39.18-.39.42 0 .211.18.422.39.422h6.287c.21-.03.39-.21.39-.421z"
      />
      <path
        fill="#F3F3F3"
        d="M74.288 47.128c.03-.24.21-.421.452-.421l2.797.21c.24.03.42.241.39.482-.03.24-.21.42-.45.42l-2.798-.21c-.21-.03-.39-.24-.39-.481z"
      />
      <path
        fill="#EFEFEF"
        d="M74.259 47.129c.03-.271.24-.452.481-.452l2.798.21c.24.031.45.242.42.512a.488.488 0 01-.48.451l-2.798-.21c-.24-.03-.421-.27-.421-.511zm3.67.27a.38.38 0 00-.361-.42l-2.798-.211c-.21 0-.391.15-.421.39-.03.211.15.422.361.422l2.798.21c.21 0 .39-.18.42-.39z"
      />
      <path
        fill="#F3F3F3"
        d="M70.408 49.325c.06-.241.27-.392.511-.361l6.166 1.233c.241.06.392.27.332.511a.463.463 0 01-.512.361l-6.166-1.233c-.21-.03-.361-.27-.33-.511z"
      />
      <path
        fill="#EFEFEF"
        d="M70.379 49.323c.06-.27.3-.42.541-.39l6.167 1.233c.24.06.42.3.36.57a.49.49 0 01-.54.392l-6.167-1.233c-.241-.06-.391-.301-.361-.571zm7.009 1.414a.431.431 0 00-.301-.482l-6.167-1.233a.427.427 0 00-.481.331c-.03.21.09.421.3.482l6.167 1.233c.24.03.421-.12.482-.331z"
      />
      <path
        fill="#F3F3F3"
        d="M73.116 52.934a.448.448 0 01.541-.33l2.707.751c.241.06.361.301.301.542a.45.45 0 01-.541.33l-2.707-.752c-.24-.06-.361-.3-.301-.541z"
      />
      <path
        fill="#EFEFEF"
        d="M73.086 52.932c.06-.24.331-.42.572-.33l2.707.751c.24.06.391.331.331.572-.06.24-.331.42-.572.33l-2.707-.751c-.24-.06-.39-.3-.33-.571zm3.52.993c.06-.21-.06-.451-.271-.511l-2.707-.752c-.21-.06-.421.06-.481.3-.06.211.06.452.27.512l2.707.752c.21.03.421-.09.482-.301z"
      />
      <path
        fill="#F3F3F3"
        d="M68.875 54.378a.43.43 0 01.572-.241l5.805 2.406c.21.09.33.361.24.572-.09.24-.36.33-.571.24l-5.805-2.406c-.24-.09-.331-.36-.24-.571z"
      />
      <path
        fill="#EFEFEF"
        d="M68.844 54.347a.468.468 0 01.602-.27l5.804 2.406c.241.09.331.361.241.632a.467.467 0 01-.602.27l-5.805-2.406c-.24-.12-.33-.391-.24-.632zm6.587 2.738c.09-.21 0-.452-.21-.542l-5.806-2.406c-.21-.09-.42.03-.511.24-.09.211 0 .452.21.542l5.805 2.406c.211.06.452-.03.512-.24z"
      />
      <path
        fill="#F3F3F3"
        d="M70.83 58.438c.12-.21.36-.3.57-.21l2.497 1.263c.21.09.3.36.18.602-.12.21-.36.3-.571.21L71.01 59.04c-.21-.12-.301-.391-.18-.602z"
      />
      <path
        fill="#EFEFEF"
        d="M70.8 58.408a.46.46 0 01.63-.21l2.497 1.263a.46.46 0 01.21.631.46.46 0 01-.63.21L71.01 59.04c-.241-.09-.331-.391-.21-.632zm3.248 1.654c.09-.21.03-.45-.18-.54l-2.497-1.264c-.181-.09-.421 0-.542.18-.09.21-.03.451.18.542l2.497 1.263c.21.09.451.03.542-.18z"
      />
      <path
        fill="#F3F3F3"
        d="M66.409 59.01c.15-.211.39-.271.601-.121l5.234 3.489c.21.12.24.391.12.601-.15.211-.39.271-.601.12l-5.234-3.488c-.21-.15-.27-.421-.12-.602z"
      />
      <path
        fill="#EFEFEF"
        d="M66.379 58.98a.52.52 0 01.662-.151l5.234 3.489c.21.15.27.42.12.662a.52.52 0 01-.661.15l-5.235-3.489c-.24-.15-.27-.451-.12-.662zm5.926 3.97c.12-.18.09-.452-.09-.572L66.98 58.89a.392.392 0 00-.542.12c-.12.18-.09.452.09.572l5.234 3.489c.18.12.421.06.542-.12z"
      />
      <path
        fill="#F3F3F3"
        d="M67.522 63.371c.15-.18.421-.24.602-.09l2.195 1.715c.18.15.21.42.06.601-.15.18-.42.24-.601.09l-2.196-1.714a.429.429 0 01-.06-.602z"
      />
      <path
        fill="#EFEFEF"
        d="M67.49 63.34c.15-.21.452-.24.662-.09l2.196 1.714c.21.15.24.452.09.662-.15.21-.451.24-.662.09l-2.195-1.714c-.211-.15-.24-.451-.09-.662zm2.888 2.256c.15-.18.12-.421-.06-.571l-2.196-1.715a.427.427 0 00-.571.09c-.15.18-.12.422.06.572l2.195 1.714c.18.12.421.09.572-.09z"
      />
      <path
        fill="#F3F3F3"
        d="M63.04 63.069c.181-.18.452-.18.602 0l4.452 4.421c.18.18.15.452 0 .602-.18.18-.451.18-.602 0L63.04 63.67a.458.458 0 010-.601z"
      />
      <path
        fill="#EFEFEF"
        d="M63.04 63.04a.472.472 0 01.662 0l4.451 4.42a.472.472 0 010 .662.472.472 0 01-.661 0l-4.452-4.42a.426.426 0 010-.663zm5.053 5.022a.418.418 0 000-.571l-4.452-4.422a.418.418 0 00-.57 0 .418.418 0 000 .572l4.45 4.421c.151.18.392.18.572 0z"
      />
      <path
        fill="#F3F3F3"
        d="M63.31 67.551c.18-.15.45-.15.601.03l1.835 2.106a.43.43 0 01-.06.602c-.18.15-.451.15-.602-.03l-1.835-2.106c-.15-.15-.12-.421.06-.602z"
      />
      <path
        fill="#EFEFEF"
        d="M63.28 67.552c.21-.18.481-.15.661.03l1.835 2.105c.18.181.15.482-.06.662a.472.472 0 01-.662-.03l-1.835-2.105c-.15-.21-.15-.511.06-.662h.001zm2.406 2.737c.18-.15.18-.391.06-.571l-1.835-2.106a.418.418 0 00-.571-.03c-.18.15-.18.391-.06.571l1.835 2.106c.15.18.39.18.57.03h.001z"
      />
      <path
        fill="#F3F3F3"
        d="M58.978 66.408c.21-.15.481-.09.602.12l3.489 5.204c.12.21.06.481-.12.602a.408.408 0 01-.602-.12l-3.49-5.204c-.12-.21-.06-.482.12-.602h.001z"
      />
      <path
        fill="#EFEFEF"
        d="M58.978 66.379a.48.48 0 01.662.12l3.489 5.203c.15.21.09.511-.15.662a.48.48 0 01-.662-.12l-3.489-5.204a.458.458 0 01.15-.661zm3.97 5.925c.18-.12.241-.361.12-.542L59.58 66.56c-.12-.18-.361-.21-.571-.09-.181.12-.241.36-.12.541l3.488 5.203c.12.15.391.211.571.09z"
      />
      <path
        fill="#F3F3F3"
        d="M58.347 70.86c.21-.12.481-.06.601.15l1.384 2.437c.12.21.03.481-.18.601a.438.438 0 01-.602-.15l-1.383-2.436c-.09-.21-.03-.481.18-.602z"
      />
      <path
        fill="#EFEFEF"
        d="M58.348 70.83c.24-.12.511-.06.632.15l1.383 2.438c.12.21.06.51-.18.631-.24.12-.512.06-.632-.15l-1.383-2.437c-.12-.21-.06-.481.18-.631zm1.805 3.19c.18-.121.27-.362.15-.542L58.92 71.04a.432.432 0 00-.542-.15c-.18.12-.27.36-.15.541l1.383 2.437c.09.18.361.27.542.15z"
      />
      <path
        fill="#F3F3F3"
        d="M54.347 68.876c.24-.09.481 0 .572.21l2.436 5.805c.09.21-.03.481-.24.571-.211.09-.482 0-.572-.21l-2.436-5.805c-.09-.21.03-.481.24-.571z"
      />
      <path
        fill="#EFEFEF"
        d="M54.347 68.844a.5.5 0 01.632.24l2.436 5.806a.467.467 0 01-.27.601c-.241.09-.512 0-.632-.24l-2.436-5.806c-.09-.21.03-.48.27-.601zm2.737 6.587c.21-.09.301-.33.21-.511l-2.435-5.805a.407.407 0 00-.541-.211c-.211.09-.302.33-.211.511l2.436 5.805c.12.211.33.301.541.211z"
      />
      <path
        fill="#F3F3F3"
        d="M52.873 73.146c.24-.09.48.03.571.271l.873 2.647c.09.21-.06.481-.271.541-.24.09-.481-.03-.571-.27l-.873-2.647c-.09-.21.03-.451.27-.542z"
      />
      <path
        fill="#EFEFEF"
        d="M52.844 73.117a.468.468 0 01.601.27l.873 2.647c.09.24-.06.512-.301.602a.468.468 0 01-.602-.27l-.872-2.648a.511.511 0 01.3-.601zm1.173 3.458c.21-.06.33-.3.27-.51l-.872-2.647c-.06-.21-.3-.301-.511-.241-.211.06-.331.3-.27.511l.871 2.647a.382.382 0 00.512.24z"
      />
      <path
        fill="#F3F3F3"
        d="M49.323 70.41c.24-.06.481.09.511.33l1.264 6.166c.06.24-.12.451-.361.511-.24.06-.482-.09-.511-.33l-1.264-6.167a.482.482 0 01.36-.511h.001z"
      />
      <path
        fill="#EFEFEF"
        d="M49.324 70.378c.27-.06.51.12.57.361l1.264 6.167c.06.24-.12.511-.361.541a.483.483 0 01-.571-.36l-1.264-6.167c-.06-.24.09-.481.361-.541zm1.413 7.01c.21-.03.36-.242.33-.482l-1.263-6.167c-.03-.21-.27-.36-.48-.3-.211.03-.361.24-.331.48l1.263 6.168c.06.21.27.33.481.3z"
      />
      <path
        fill="#F3F3F3"
        d="M47.039 74.319c.24-.03.45.12.511.36l.36 2.767c.03.241-.15.452-.39.482a.462.462 0 01-.511-.361l-.361-2.767a.438.438 0 01.39-.481z"
      />
      <path
        fill="#EFEFEF"
        d="M47.038 74.288c.27-.03.511.15.542.392l.36 2.767c.03.24-.15.481-.42.511-.272.03-.512-.15-.543-.391l-.36-2.767a.468.468 0 01.42-.512zm.451 3.61c.21-.03.392-.24.361-.451l-.36-2.767a.403.403 0 00-.452-.331c-.21.03-.392.24-.361.45l.36 2.768c.03.21.242.361.452.33z"
      />
      <path
        fill="#F3F3F3"
        d="M43.94 70.95c.241 0 .452.18.452.42v6.287c0 .24-.211.421-.452.421-.24 0-.45-.18-.45-.42V71.37c.03-.24.21-.421.45-.421z"
      />
      <path
        fill="#EFEFEF"
        d="M43.94 70.92c.27 0 .48.21.48.45v6.287c0 .24-.21.451-.48.451-.271 0-.482-.21-.482-.45V71.37c0-.24.24-.451.481-.451zm0 7.129c.21 0 .42-.18.42-.392v-6.286c0-.21-.18-.391-.42-.391-.211 0-.422.18-.422.391v6.286c.03.211.21.392.421.392z"
      />
      <path
        fill="#F3F3F3"
        d="M40.932 74.318c.24.03.421.21.421.451l-.21 2.798a.438.438 0 01-.482.39c-.24-.03-.42-.21-.42-.45l.21-2.798c.03-.24.24-.421.481-.39z"
      />
      <path
        fill="#EFEFEF"
        d="M40.933 74.288c.27.03.45.24.45.482l-.21 2.797c-.03.24-.24.451-.51.421a.489.489 0 01-.452-.481l.21-2.798c.03-.27.241-.45.512-.42zm-.27 3.64c.21 0 .42-.15.42-.36l.21-2.798c0-.21-.15-.391-.39-.421-.21 0-.421.15-.421.36l-.21 2.798c0 .21.18.391.39.421z"
      />
      <path
        fill="#F3F3F3"
        d="M38.677 70.408c.24.06.39.27.36.511l-1.232 6.167c-.06.24-.271.391-.512.33a.462.462 0 01-.36-.51l1.233-6.167c.03-.21.27-.36.511-.33z"
      />
      <path
        fill="#EFEFEF"
        d="M38.676 70.378a.49.49 0 01.39.542l-1.233 6.166c-.06.24-.3.421-.57.361a.49.49 0 01-.392-.542l1.233-6.166c.06-.24.301-.39.572-.36zm-1.414 7.009c.21.03.421-.09.481-.3l1.233-6.167a.426.426 0 00-.33-.481.432.432 0 00-.482.3l-1.233 6.166c-.03.241.12.422.331.482z"
      />
      <path
        fill="#F3F3F3"
        d="M35.068 73.116c.24.06.39.3.33.541l-.752 2.707c-.06.24-.3.36-.54.301a.45.45 0 01-.332-.541l.752-2.707c.06-.24.301-.361.542-.301z"
      />
      <path
        fill="#EFEFEF"
        d="M35.066 73.087c.241.06.422.33.331.571l-.752 2.707a.48.48 0 01-.57.33c-.241-.059-.422-.33-.332-.57l.752-2.707c.06-.241.301-.392.572-.331zm-.992 3.519c.21.06.451-.06.512-.27l.751-2.708c.06-.21-.06-.42-.3-.481-.21-.06-.451.06-.512.27l-.752 2.708c-.03.21.09.42.301.48z"
      />
      <path
        fill="#F3F3F3"
        d="M33.593 68.875c.24.09.33.361.24.572l-2.405 5.805c-.09.21-.362.33-.572.21-.21-.12-.331-.36-.24-.571l2.406-5.805c.09-.21.36-.331.57-.21h.001z"
      />
      <path
        fill="#EFEFEF"
        d="M33.593 68.845a.467.467 0 01.27.602l-2.406 5.805c-.09.24-.361.33-.632.24a.467.467 0 01-.27-.601l2.406-5.805c.12-.24.391-.361.632-.24zm-2.738 6.587c.21.09.451 0 .542-.21l2.406-5.805c.09-.21-.03-.422-.24-.512a.408.408 0 00-.542.21l-2.406 5.806c-.06.18.03.421.24.511z"
      />
      <path
        fill="#F3F3F3"
        d="M29.532 70.8c.21.12.3.36.21.57l-1.263 2.497a.44.44 0 01-.602.18c-.21-.12-.3-.36-.21-.57l1.263-2.497a.44.44 0 01.602-.18z"
      />
      <path
        fill="#EFEFEF"
        d="M29.534 70.77c.24.12.33.39.21.63l-1.263 2.497a.46.46 0 01-.631.21.46.46 0 01-.21-.631l1.262-2.496a.46.46 0 01.632-.21zm-1.654 3.278c.21.09.45.03.54-.181l1.264-2.496c.09-.18 0-.421-.18-.542-.21-.09-.451-.03-.542.18L27.7 73.507c-.09.18 0 .421.18.541z"
      />
      <path
        fill="#F3F3F3"
        d="M28.93 66.35c.21.15.27.42.12.6l-3.489 5.205c-.12.21-.391.24-.601.12-.21-.15-.271-.421-.12-.602l3.488-5.204c.12-.21.391-.27.602-.12z"
      />
      <path
        fill="#EFEFEF"
        d="M28.93 66.317c.21.151.27.452.15.662l-3.489 5.204a.476.476 0 01-.661.12.52.52 0 01-.151-.662l3.49-5.203a.48.48 0 01.66-.12zm-3.97 5.926c.18.12.45.09.571-.09l3.49-5.204a.392.392 0 00-.121-.541c-.18-.12-.451-.09-.572.09L24.84 71.67c-.12.181-.06.452.12.572z"
      />
      <path
        fill="#F3F3F3"
        d="M24.538 67.46c.181.151.241.422.09.602l-1.744 2.196a.429.429 0 01-.601.06c-.18-.15-.24-.421-.09-.602l1.744-2.195c.15-.18.421-.21.601-.06z"
      />
      <path
        fill="#EFEFEF"
        d="M24.57 67.431c.21.15.24.452.09.662l-1.745 2.196c-.15.21-.451.24-.662.06-.21-.15-.24-.451-.09-.662l1.745-2.195c.15-.211.45-.24.662-.06zm-2.256 2.858c.18.15.42.12.571-.06l1.745-2.196a.426.426 0 00-.09-.571c-.181-.151-.422-.12-.572.06l-1.745 2.195c-.12.181-.09.451.09.572z"
      />
      <path
        fill="#F3F3F3"
        d="M24.84 62.95c.18.18.18.451 0 .601l-4.451 4.422a.426.426 0 01-.602 0c-.15-.15-.18-.451 0-.602l4.422-4.42c.18-.182.45-.182.631 0z"
      />
      <path
        fill="#EFEFEF"
        d="M24.87 62.919a.472.472 0 010 .66l-4.452 4.423a.472.472 0 01-.661 0 .472.472 0 010-.662l4.45-4.421a.472.472 0 01.662 0zm-5.084 5.053c.15.15.421.15.572 0l4.451-4.422a.418.418 0 000-.572.418.418 0 00-.571 0L19.786 67.4c-.15.15-.15.391 0 .571z"
      />
      <path
        fill="#F3F3F3"
        d="M20.328 63.19c.15.18.15.45-.03.601l-2.136 1.805a.43.43 0 01-.602-.06c-.15-.181-.15-.451.03-.602l2.136-1.805c.18-.15.451-.12.602.06z"
      />
      <path
        fill="#EFEFEF"
        d="M20.359 63.16c.18.21.15.511-.03.662l-2.136 1.804c-.18.18-.481.15-.661-.06-.181-.21-.151-.511.03-.662l2.135-1.804c.18-.18.482-.15.662.06zm-2.768 2.376c.151.18.392.18.572.06l2.136-1.805c.15-.15.18-.39.03-.57-.15-.181-.392-.181-.572-.061l-2.135 1.804c-.18.15-.18.392-.03.572z"
      />
      <path
        fill="#F3F3F3"
        d="M21.532 58.859c.15.21.09.481-.12.602l-5.234 3.489c-.21.12-.481.06-.601-.12a.407.407 0 01.12-.602l5.234-3.49c.18-.12.45-.06.601.121z"
      />
      <path
        fill="#EFEFEF"
        d="M21.562 58.858c.15.21.09.511-.12.662l-5.234 3.489a.463.463 0 01-.661-.15.48.48 0 01.12-.662l5.233-3.49c.21-.15.511-.09.662.151zm-5.955 3.94c.12.18.36.24.54.12l5.234-3.489c.181-.12.24-.36.09-.57a.392.392 0 00-.54-.121l-5.234 3.489c-.18.15-.21.39-.09.571z"
      />
      <path
        fill="#F3F3F3"
        d="M17.05 58.226c.12.21.06.482-.15.602l-2.436 1.383c-.21.12-.482.03-.602-.18a.438.438 0 01.15-.602l2.437-1.383c.21-.12.481-.03.602.18z"
      />
      <path
        fill="#EFEFEF"
        d="M17.08 58.197c.12.24.06.51-.15.631l-2.436 1.384c-.21.12-.512.03-.632-.18-.12-.241-.06-.512.15-.632l2.437-1.384c.21-.12.511-.03.631.18zM13.893 60c.12.21.361.271.542.15l2.436-1.383c.18-.12.24-.36.15-.541-.12-.21-.36-.271-.541-.15l-2.436 1.383c-.18.09-.241.33-.15.541h-.001z"
      />
      <path
        fill="#F3F3F3"
        d="M19.064 54.227c.09.24 0 .482-.24.572l-5.805 2.406c-.21.09-.482-.03-.572-.24-.09-.241 0-.482.241-.572l5.805-2.406a.43.43 0 01.572.24z"
      />
      <path
        fill="#EFEFEF"
        d="M19.095 54.197c.09.24 0 .511-.241.631l-5.805 2.407a.468.468 0 01-.601-.271c-.09-.24 0-.511.24-.632l5.805-2.406a.467.467 0 01.602.27zm-6.588 2.737c.09.21.331.301.512.24l5.805-2.406c.21-.09.3-.33.21-.541a.428.428 0 00-.511-.24l-5.805 2.406c-.21.09-.3.33-.21.541z"
      />
      <path
        fill="#F3F3F3"
        d="M14.825 52.723c.09.24-.03.48-.27.57l-2.648.873c-.21.09-.481-.06-.541-.27-.09-.241.03-.482.27-.572l2.647-.872c.211-.09.452.03.542.27z"
      />
      <path
        fill="#EFEFEF"
        d="M14.853 52.693a.46.46 0 01-.3.601l-2.647.873c-.241.09-.512-.06-.602-.301a.46.46 0 01.301-.602l2.647-.872c.24-.06.511.06.601.3zm-3.489 1.143c.06.21.301.33.512.27l2.647-.872c.21-.06.3-.3.24-.511-.06-.21-.3-.331-.511-.27l-2.647.872c-.21.09-.3.3-.24.51z"
      />
      <path
        fill="#F3F3F3"
        d="M17.532 49.143c.06.24-.09.481-.33.511l-6.167 1.203c-.24.06-.451-.12-.511-.36-.06-.242.09-.482.33-.512l6.167-1.203c.24-.03.481.12.51.36h.001z"
      />
      <path
        fill="#EFEFEF"
        d="M17.592 49.143c.06.27-.12.511-.361.571l-6.166 1.203c-.241.06-.482-.12-.542-.39a.483.483 0 01.361-.572l6.166-1.203c.24-.06.482.12.542.39zm-7.009 1.354c.03.21.241.36.451.33l6.167-1.203c.21-.03.36-.27.3-.481a.404.404 0 00-.45-.331l-6.167 1.203c-.21.06-.36.27-.3.481z"
      />
      <path
        fill="#F3F3F3"
        d="M13.682 46.828c.03.24-.12.45-.362.481l-2.767.33a.438.438 0 01-.48-.39c-.03-.24.12-.451.36-.482l2.767-.33c.21-.03.451.15.482.39z"
      />
      <path
        fill="#EFEFEF"
        d="M13.712 46.828c.03.27-.15.51-.391.541l-2.767.331a.468.468 0 01-.512-.421c-.03-.27.15-.511.391-.541l2.768-.331c.24-.03.48.15.51.42h.001zm-3.64.42c.03.211.241.392.452.362l2.767-.331c.21-.03.36-.24.33-.451-.03-.21-.24-.391-.45-.361l-2.768.33c-.21.03-.36.241-.33.452z"
      />
      <path
        fill="#F3F3F3"
        d="M17.049 43.909c0 .24-.18.451-.421.451h-6.286c-.24 0-.421-.21-.421-.45 0-.241.18-.452.42-.452h6.287c.24 0 .422.21.422.451h-.001z"
      />
      <path
        fill="#EFEFEF"
        d="M17.08 43.91c0 .27-.21.48-.451.48h-6.286c-.24 0-.451-.21-.451-.48 0-.271.21-.482.45-.482h6.287c.24 0 .451.21.451.481zm-7.128-.03c0 .21.18.42.39.42h6.287c.21 0 .391-.18.391-.42 0-.211-.18-.422-.391-.422h-6.286c-.21.03-.391.211-.391.422z"
      />
      <path
        fill="#E2E2E2"
        d="M13.711 40.873c-.03.24-.21.42-.451.42l-2.797-.21a.438.438 0 01-.391-.481c.03-.24.21-.421.451-.421l2.797.21c.21.03.391.24.391.482z"
      />
      <path
        fill="#EFEFEF"
        d="M13.741 40.871a.488.488 0 01-.48.451l-2.798-.21c-.24-.03-.451-.24-.421-.512.03-.27.24-.45.481-.45l2.797.21c.24.03.421.27.421.511zm-3.67-.27c-.03.21.151.42.362.42l2.797.211c.21 0 .391-.15.421-.39a.38.38 0 00-.36-.422l-2.798-.21c-.21 0-.391.18-.421.39z"
      />
      <path
        fill="#F3F3F3"
        d="M17.592 38.675a.463.463 0 01-.511.361l-6.166-1.263c-.241-.06-.392-.27-.331-.511.06-.24.27-.391.511-.361l6.166 1.233c.21.06.361.3.33.541z"
      />
      <path
        fill="#EFEFEF"
        d="M17.62 38.676a.49.49 0 01-.54.39l-6.166-1.232a.484.484 0 01-.361-.572.49.49 0 01.54-.39l6.167 1.232c.24.06.39.301.36.572zm-7.007-1.414c-.03.21.09.421.3.481l6.167 1.234c.21.03.42-.09.48-.331a.432.432 0 00-.3-.482l-6.166-1.233c-.24-.03-.42.12-.481.331z"
      />
      <path
        fill="#F3F3F3"
        d="M14.885 35.066a.448.448 0 01-.541.331l-2.708-.752c-.24-.06-.36-.3-.3-.541a.45.45 0 01.541-.331l2.707.752c.24.06.361.3.301.541z"
      />
      <path
        fill="#EFEFEF"
        d="M14.915 35.067c-.06.24-.331.421-.572.33l-2.707-.751a.48.48 0 01-.33-.572c.06-.24.33-.42.57-.33l2.708.751c.24.06.391.301.33.572zm-3.52-.993c-.06.21.06.451.271.511l2.707.752c.211.06.422-.06.482-.3.06-.211-.06-.452-.271-.512l-2.707-.752a.431.431 0 00-.481.301z"
      />
      <path
        fill="#F3F3F3"
        d="M19.125 33.623c-.09.24-.361.33-.571.24l-5.806-2.406c-.21-.09-.33-.361-.24-.572.09-.24.36-.33.571-.24l5.805 2.406c.241.09.331.36.241.571z"
      />
      <path
        fill="#EFEFEF"
        d="M19.156 33.653a.467.467 0 01-.601.271l-5.806-2.406c-.24-.09-.33-.36-.24-.632a.467.467 0 01.602-.27l5.805 2.406c.24.12.33.391.24.631zm-6.587-2.736c-.09.21 0 .45.21.54l5.806 2.407c.21.09.42-.03.511-.24.09-.211 0-.452-.21-.542l-5.805-2.406c-.211-.06-.452.03-.512.24z"
      />
      <path
        fill="#F3F3F3"
        d="M17.17 29.563c-.12.21-.36.301-.57.21l-2.498-1.262c-.21-.09-.3-.361-.18-.602.12-.21.36-.301.571-.21l2.497 1.263c.21.12.3.391.18.601z"
      />
      <path
        fill="#EFEFEF"
        d="M17.2 29.593a.46.46 0 01-.631.21l-2.497-1.263a.46.46 0 01-.21-.631.46.46 0 01.631-.211l2.496 1.263c.241.09.331.392.211.632zm-3.248-1.654c-.09.21-.03.45.18.541l2.497 1.264c.18.09.421 0 .541-.181.09-.21.03-.451-.18-.542l-2.527-1.262a.371.371 0 00-.511.18z"
      />
      <path
        fill="#F3F3F3"
        d="M21.591 28.99c-.15.212-.39.272-.601.121l-5.204-3.459c-.21-.12-.24-.39-.12-.601.12-.21.391-.271.602-.12l5.233 3.488c.18.12.24.392.09.572z"
      />
      <path
        fill="#EFEFEF"
        d="M21.622 29.021a.52.52 0 01-.662.15l-5.203-3.489a.475.475 0 01-.12-.66.52.52 0 01.661-.151l5.204 3.488c.24.151.27.451.12.662zm-5.926-3.97c-.12.18-.09.451.09.571l5.234 3.49c.18.12.421.06.542-.12.12-.181.09-.452-.09-.572l-5.234-3.49a.392.392 0 00-.542.12z"
      />
      <path
        fill="#F3F3F3"
        d="M20.479 24.63c-.15.18-.421.24-.601.09l-2.196-1.714a.43.43 0 01-.06-.602c.15-.18.42-.24.601-.09l2.196 1.714c.18.15.21.42.06.602z"
      />
      <path
        fill="#EFEFEF"
        d="M20.508 24.66c-.15.21-.45.24-.661.09l-2.196-1.714c-.21-.15-.24-.45-.09-.661.15-.21.451-.241.661-.09l2.196 1.714c.21.15.24.45.09.662v-.001zm-2.887-2.256c-.15.18-.12.421.06.572l2.196 1.714c.18.12.42.09.571-.09.15-.18.12-.42-.06-.571l-2.196-1.715a.426.426 0 00-.57.09h-.001z"
      />
      <path
        fill="#F3F3F3"
        d="M24.96 24.931c-.18.181-.451.181-.601 0l-4.482-4.421a.426.426 0 010-.602c.18-.18.451-.18.602 0l4.451 4.422c.18.15.18.451.03.602z"
      />
      <path
        fill="#EFEFEF"
        d="M24.96 24.96a.471.471 0 01-.66 0l-4.453-4.421a.472.472 0 010-.662.472.472 0 01.662 0l4.452 4.421c.21.18.21.482 0 .662zm-5.052-5.023a.418.418 0 000 .571l4.452 4.422c.15.15.42.15.57 0a.418.418 0 000-.571l-4.45-4.452c-.15-.15-.392-.15-.572.03z"
      />
      <path
        fill="#F3F3F3"
        d="M24.69 20.45c-.18.15-.45.15-.6-.03l-1.836-2.106a.43.43 0 01.06-.601c.18-.15.452-.15.602.03l1.835 2.105c.15.15.12.421-.06.602z"
      />
      <path
        fill="#EFEFEF"
        d="M24.72 20.45a.472.472 0 01-.662-.03l-1.835-2.106c-.18-.18-.15-.481.06-.662.21-.18.481-.15.662.03l1.835 2.106c.15.21.15.511-.06.662zm-2.407-2.737c-.18.15-.18.39-.06.57l1.835 2.106c.15.15.39.181.571.03.18-.15.18-.39.06-.57l-1.834-2.107c-.15-.18-.392-.18-.572-.03z"
      />
      <path
        fill="#F3F3F3"
        d="M29.021 21.593a.408.408 0 01-.601-.12l-3.52-5.204c-.12-.21-.06-.482.12-.602.211-.15.482-.09.602.12l3.49 5.204c.15.21.09.481-.09.602z"
      />
      <path
        fill="#EFEFEF"
        d="M29.02 21.621a.481.481 0 01-.661-.12l-3.489-5.204a.463.463 0 01.15-.66.48.48 0 01.662.12l3.489 5.203c.15.24.09.511-.15.661zm-3.97-5.925c-.18.12-.24.36-.12.542l3.489 5.203c.12.18.36.21.57.09.182-.12.242-.36.121-.541l-3.488-5.174a.428.428 0 00-.571-.12z"
      />
      <path
        fill="#F3F3F3"
        d="M29.652 17.14a.438.438 0 01-.601-.15l-1.384-2.437c-.12-.21-.03-.481.18-.602.211-.12.482-.06.602.15l1.384 2.437c.09.21.03.481-.18.602z"
      />
      <path
        fill="#EFEFEF"
        d="M29.654 17.17c-.241.12-.512.06-.632-.15l-1.384-2.437c-.12-.21-.06-.511.18-.632.241-.12.512-.06.632.15l1.384 2.437c.12.21.06.481-.18.632zm-1.805-3.189c-.18.12-.27.361-.15.542l1.383 2.436c.12.18.361.241.541.15.181-.12.271-.36.15-.54l-1.383-2.437c-.09-.18-.36-.271-.541-.15z"
      />
      <path
        fill="#F3F3F3"
        d="M33.653 19.126c-.24.09-.481 0-.571-.21l-2.437-5.806c-.09-.21.03-.481.241-.572.24-.09.481 0 .571.21l2.437 5.806c.09.21-.03.481-.241.571v.001z"
      />
      <path
        fill="#EFEFEF"
        d="M33.654 19.156c-.24.09-.511 0-.632-.241l-2.436-5.805a.467.467 0 01.27-.601.5.5 0 01.632.24l2.437 5.805c.09.21-.03.482-.271.602zm-2.737-6.587c-.21.09-.301.33-.21.511l2.435 5.805c.09.21.331.3.541.21.211-.09.302-.33.211-.51l-2.436-5.806c-.12-.21-.331-.3-.541-.21z"
      />
      <path
        fill="#F3F3F3"
        d="M35.126 14.855c-.241.09-.482-.03-.572-.27l-.872-2.648c-.09-.21.06-.48.27-.54.211-.06.482.03.572.27l.872 2.647c.09.21-.03.451-.27.541z"
      />
      <path
        fill="#EFEFEF"
        d="M35.157 14.885a.467.467 0 01-.6-.271l-.873-2.647c-.09-.24.06-.511.3-.601a.467.467 0 01.602.27l.872 2.647c.06.24-.06.512-.3.602zm-1.172-3.46c-.211.06-.331.301-.271.512l.872 2.647c.06.21.3.3.512.24.21-.06.33-.3.27-.51l-.872-2.648a.38.38 0 00-.512-.24z"
      />
      <path
        fill="#F3F3F3"
        d="M38.675 17.592c-.24.06-.481-.09-.511-.331L36.9 11.095c-.06-.24.12-.451.361-.511s.481.09.511.33l1.264 6.167c.03.21-.12.45-.361.51z"
      />
      <path
        fill="#EFEFEF"
        d="M38.676 17.621a.484.484 0 01-.572-.36l-1.263-6.167c-.06-.24.12-.511.36-.541.272-.06.512.12.572.36l1.264 6.167c.06.24-.09.481-.361.541zm-1.414-7.008c-.21.03-.361.24-.33.481l1.262 6.166c.03.21.27.361.482.3.21-.03.36-.24.33-.48l-1.263-6.166a.432.432 0 00-.481-.301z"
      />
      <path
        fill="#F3F3F3"
        d="M40.962 13.681a.462.462 0 01-.511-.36l-.36-2.768a.438.438 0 01.39-.481c.24-.03.451.12.511.361l.361 2.767c.03.24-.15.451-.39.481z"
      />
      <path
        fill="#EFEFEF"
        d="M40.963 13.711c-.27.03-.511-.15-.541-.39l-.361-2.768a.468.468 0 01.42-.511c.272-.03.512.15.542.391l.361 2.767c.03.24-.15.481-.42.511zm-.451-3.609c-.21.03-.391.24-.361.451l.361 2.767c.03.211.24.361.451.331.21-.03.391-.24.361-.45l-.36-2.768a.403.403 0 00-.452-.331z"
      />
      <path
        fill="url(#safari_inactive_paint2_linear)"
        fillOpacity="0.2"
        d="M44.211 79.582c19.668 0 35.613-15.944 35.613-35.612S63.879 8.357 44.21 8.357 8.6 24.302 8.6 43.97 24.543 79.582 44.21 79.582z"
      />
      <path
        fill="#000"
        fillOpacity="0.05"
        d="M68.875 21.382L40.15 39.79h-.03v.03l-.03.03-17.926 29.567 26.348-21.205.03-.03v-.03l20.333-26.77z"
      />
      <path
        fill="#909090"
        d="M68.333 19.666L39.94 39.85l8.421 8.361 19.972-28.544z"
      />
      <path
        fill="#AAAAAA"
        d="M39.969 39.789l4.24 4.18 24.123-24.303L39.97 39.79z"
      />
      <path
        fill="#B9B9B9"
        d="M39.969 39.79l8.422 8.36-28.394 20.183L39.97 39.79z"
      />
      <path
        fill="#EDEDED"
        d="M19.997 68.333L44.21 43.97l-4.241-4.181-19.972 28.544z"
      />
      <defs>
        <linearGradient
          id="safari_inactive_paint0_linear"
          x1="44"
          x2="44"
          y1="82.5"
          y2="5.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25" stopColor="#C4C4C4" />
          <stop offset="1" stopColor="#FDFDFD" />
        </linearGradient>
        <radialGradient
          id="safari_inactive_paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(49.003 36.177) scale(43.47)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AAAAAA" />
          <stop offset="0.114" stopColor="#C4C4C4" />
          <stop offset="1" stopColor="#909090" />
        </radialGradient>
        <linearGradient
          id="safari_inactive_paint2_linear"
          x1="43.535"
          x2="26.913"
          y1="33.787"
          y2="63.608"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
